import { render, staticRenderFns } from "./cardInformacionUsuario.vue?vue&type=template&id=9151f0a8"
import script from "./cardInformacionUsuario.vue?vue&type=script&lang=js"
export * from "./cardInformacionUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports